import { type CSSVariablesResolver, createTheme } from "@mantine/core";

export const theme = createTheme({});

export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: {},
  dark: {},
});
